import { tr } from "../../i18n";
/**
 * CoppaChampions — coppa "orecchioni" in SVG, per la finale del tabellone.
 *
 * Andrea 2026-09-09: in fondo al tabellone a eliminazione ci va la coppa,
 * spenta finché non c'è un campione e dorata quando la finale è decisa.
 */

interface CoppaChampionsProps {
  size?: number;
  /** false = coppa "spenta" (finale ancora da giocare). */
  vinta?: boolean;
  className?: string;
}

export function CoppaChampions({ size = 64, vinta = false, className = "" }: CoppaChampionsProps) {
  const corpo = vinta ? "#f2d16b" : "#6b7089";
  const bordo = vinta ? "#fff3c4" : "#8b90a8";
  const base = vinta ? "#c9a63f" : "#565b73";
  return (
    <svg
      viewBox="0 0 64 80"
      width={size}
      height={(size * 80) / 64}
      className={className}
      role="img"
      aria-label={vinta ? tr("Coppa vinta") : tr("Coppa in gioco")}
    >
      {/* orecchioni */}
      <path
        d="M17 13 C3 16 3 36 17 39"
        fill="none"
        stroke={bordo}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M47 13 C61 16 61 36 47 39"
        fill="none"
        stroke={bordo}
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* coppa */}
      <path
        d="M15 9 h34 v19 c0 13 -7.5 23 -17 23 s-17 -10 -17 -23 z"
        fill={corpo}
        stroke={bordo}
        strokeWidth="2"
      />
      {/* riflesso */}
      <path
        d="M22 13 v14 c0 7 2 12 5 15"
        fill="none"
        stroke={bordo}
        strokeWidth="2"
        opacity="0.7"
      />
      {/* stelo + base */}
      <rect x="28" y="50" width="8" height="11" fill={base} />
      <rect x="22" y="61" width="20" height="5" rx="1.5" fill={base} />
      <rect x="18" y="66" width="28" height="6" rx="2" fill={corpo} />
    </svg>
  );
}
